<div class="footer bg-grad">
  <app-whatsapp-link></app-whatsapp-link>
  <footer class="pt-5 container">
    <div class="footerResponsive text-center">
      <div class="col-sm-3 itemFooter">
        <a href="javascript:void(0);">
          <img alt="logo" class="logo" [src]="logo$ | async">
        </a>
      </div>

      <div class="col-sm-3">
        <h5>Institucional</h5>
        <ul class="nav flex-column">
          <li class="nav-item mb-2">
            <a routerLink="about-us" class="nav-link p-0 text-white">Sobre nós</a>
          </li>
          <li class="nav-item mb-2" *ngIf="enableSolutionsLink">
            <a routerLink="solucoes" class="nav-link p-0 text-white">Soluções</a>
          </li>
          <li class="nav-item mb-2">
            <a routerLink="terms-of-use" class="nav-link p-0 text-white">Termos de uso</a>
          </li>
          <li class="nav-item mb-2">
            <a routerLink="privacy-policy" class="nav-link p-0 text-white">Política de Privacidade</a>
          </li>
          <li class="nav-item mb-2">
            <a routerLink="half-price-policy" class="nav-link p-0 text-white">Política de meia entrada</a>
          </li>
          <!-- <li class="nav-item mb-2" *ngIf="faqUrl">
            <a target="_blank" [href]="faqUrl" class="nav-link p-0 text-white">Faq</a>
          </li> -->
        </ul>
      </div>

      <div class="col-sm-3">
        <h5>Localização</h5>
        <ul class="nav align-items-center justify-content-center ">
          <li class="nav-item mb-2" [innerHTML]="address"></li>
        </ul>
      </div>

      <div class="col-sm-3" *ngIf="configs$ | async as config">
        <div *ngIf="(config.urlAndroid  && config.urlAndroid != '' && config.urlAndroid != '#') || (config.urlios && config.urlios != '' && config.urlios != '#')">
          <h5>Baixe</h5>
          
          <ul class="nav flex-column">
            <li  class="nav-item mb-2" *ngIf="config.urlAndroid && config.urlAndroid != '' && config.urlAndroid != '#'">
              <a 
                [href]="config.urlAndroid" 
                target="_blank" 
                class="nav-link p-0 text-white"
              >
                <img class="store" src="../../../assets/images/googleplay-icone.png">
              </a>
            </li>

            <li class="nav-item mb-2" *ngIf="config.urlios && config.urlios != '' && config.urlios != '#'">
              <a 
                [href]="config.urlios"
                target="_blank"
                class="nav-link p-0 text-white"
              >
                <img class="store" src="../../../assets/images/appstore-icone.png">
              </a>
            </li>
          </ul>
        </div>

        <div class="d-flex flex-column" *ngIf="config?.socialNetworks
        && (config.socialNetworks?.instagram && config.socialNetworks?.instagram != '' && config.socialNetworks?.instagram !='#')
        || (config.socialNetworks?.facebook && config.socialNetworks?.facebook != '' && config.socialNetworks?.facebook != '#')
        || (config.socialNetworks?.tiktok && config.socialNetworks?.tiktok != '' && config.socialNetworks?.tiktok !='#')
        ">
          <h5 class="mt-3">Redes Sociais</h5>
          <div class="d-flex gap-3 justify-content-center align-items-center">
            <a 
              [href]="config.socialNetworks?.instagram"
              target="_blank"
              *ngIf="config.socialNetworks?.instagram && config.socialNetworks?.instagram != '' && config.socialNetworks?.instagram !='#'"
            >
              <i class="bi bi-instagram text-white fs-4"></i>
            </a>

            <a 
              [href]="config.socialNetworks?.tiktok" 
              target="_blank"
              *ngIf="config.socialNetworks?.tiktok && config.socialNetworks?.tiktok != '' && config.socialNetworks?.tiktok !='#'"
            >
              <i class="bi bi-tiktok text-white fs-4"></i>
            </a>

            <a 
              [href]="config.socialNetworks?.facebook" 
              target="_blank"
              *ngIf="config.socialNetworks?.facebook && config.socialNetworks?.facebook != '' && config.socialNetworks?.facebook !='#'"
            >
              <i class="bi bi-facebook text-white fs-4"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-flex justify-content-center py-4 mt-5 border-top"
      *ngIf="configs$ | async as config"
    >
      <p 
        class="text-center"
        [innerHTML]="config.company"
        *ngIf="config.company"
      ></p>
    </div>
  </footer>
</div>
